module.exports = __webpack_public_path__ + "8ae71ebdd8384aab389fafbf788177b6.png";